
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jHois", function(module, exports) {

var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

const $e3adf083a3ceeb07$export$3cf4b7499c49a1bc = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY)
});
const $e3adf083a3ceeb07$export$f38e95ed03e5cac6 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_INTERACTION)
});
const $e3adf083a3ceeb07$export$fe68f7d0c5f4b391 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION)
});
const $e3adf083a3ceeb07$export$f35c906f54c0512a = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.PAGE_ANALYTICS_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$aa2d84a67f31f760 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SPACE_ANALYTICS_PAGE_LOAD_KEY)
});
const $e3adf083a3ceeb07$export$73b0f2ef62226204 = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.SITE_ANALYTICS_LOAD_KEY)
});
module.exports["CONTENT_ANALYTICS_VIEWERS_METRIC"] = $e3adf083a3ceeb07$export$3cf4b7499c49a1bc;
module.exports["CONTENT_ANALYTICS_DIALOG_METRIC"] = $e3adf083a3ceeb07$export$f38e95ed03e5cac6;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_METRIC"] = $e3adf083a3ceeb07$export$fe68f7d0c5f4b391;
module.exports["PAGE_ANALYTICS_PAGE_LOAD_METRIC"] = $e3adf083a3ceeb07$export$f35c906f54c0512a;
module.exports["SPACE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$aa2d84a67f31f760;
module.exports["SITE_ANALYTICS_PAGE_LOAD"] = $e3adf083a3ceeb07$export$73b0f2ef62226204;

});

parcelRegister("pG0Ei", function(module, exports) {
var $8787696ab5570b52$export$b8ca5fa4899cbfc7 = /*#__PURE__*/ function(AccountType) {
    AccountType["NORMAL"] = "normal";
    AccountType["GUEST"] = "guest";
    AccountType["ANONYMOUS"] = "anonymous";
    return AccountType;
}({});
module.exports["AccountType"] = $8787696ab5570b52$export$b8ca5fa4899cbfc7;

});

parcelRegister("5Rd17", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $esRft = parcelRequire("esRft");


var $kpdGL = parcelRequire("kpdGL");


var $1Whri = parcelRequire("1Whri");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");


var $fVUfS = parcelRequire("fVUfS");


var $hezkK = parcelRequire("hezkK");


var $hge3g = parcelRequire("hge3g");


var $lE8sM = parcelRequire("lE8sM");


var $jmjWc = parcelRequire("jmjWc");


var $hjyA9 = parcelRequire("hjyA9");










const $bba20334be910b9f$export$e23ae35269442b4f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { label: t1, size: t2 } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? 16 : t2;
    const clipId = (0, $42omo.useId)();
    const t3 = label ? "img" : "presentation";
    const t4 = label || undefined;
    const t5 = label ? undefined : true;
    const t6 = `url(#${clipId})`;
    let t10;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
            fill: "#1868DB"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
            fill: "#6A9A23"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
            fill: "#AF59E1"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
            fill: "#FCA700"
        });
        $[0] = t10;
        $[1] = t7;
        $[2] = t8;
        $[3] = t9;
    } else {
        t10 = $[0];
        t7 = $[1];
        t8 = $[2];
        t9 = $[3];
    }
    let t11;
    if ($[4] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
            clipPath: t6
        }, t7, t8, t9, t10);
        $[4] = t6;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white"
        });
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== clipId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
            id: clipId
        }, t12));
        $[7] = clipId;
        $[8] = t13;
    } else t13 = $[8];
    let t14;
    if ($[9] !== size || $[10] !== t11 || $[11] !== t13 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5
        }, t11, t13);
        $[9] = size;
        $[10] = t11;
        $[11] = t13;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $42omo.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};



const $4580118d363597fd$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qxMxj",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("4lbbz"))).CursorIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $4580118d363597fd$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5osh",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("cUEQB"))).ClaudeIcon
});

const $4580118d363597fd$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bqiWP",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("2F3cm"))).ChatGptIcon
});

const $4580118d363597fd$var$FigmaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8mOo8",
    name: "FigmaIcon",
    loader: async ()=>(await (parcelRequire("3CO4t"))).FigmaIcon
}); /**
     * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
     * cases, so — like the other brand icons — they are code-split into their own chunks and
     * loaded after paint.
     */ 

const $4580118d363597fd$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00ZJa",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("knPv8"))).DiaIcon
});

const $4580118d363597fd$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fycRd",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("7bNvW"))).CodexIcon
});
const $4580118d363597fd$export$8f1cb3c7f8edc6be = (0, $aXWIB.defineMessages)({
    expandAgentRow: {
        id: "confluence-analytics.agent-activity.expand-agent-row",
        defaultMessage: "Show the people who used this agent"
    },
    collapseAgentRow: {
        id: "confluence-analytics.agent-activity.collapse-agent-row",
        defaultMessage: "Hide the people who used this agent"
    },
    agentSubtitle: {
        id: "confluence-analytics.agent-activity.agent-subtitle",
        defaultMessage: "with {name}{count, plural, =0 {} one { and # other} other { and # others}}"
    }
});
const $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE = 'small';
const $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE = 'xsmall';
const $4580118d363597fd$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $4580118d363597fd$var$styles = {
    toggleSmall: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _vchhusvi _ahbqv77o _12l2v77o _bfhksm61",
    toggleMedium: "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _1o9zidpf _vchhusvi _12l2v77o _bfhksm61",
    childIndent: "_bozg1jfw",
    iconWrapperSmall: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _ahbqv77o _12l2v77o",
    iconWrapperMedium: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _1o9zidpf _12l2v77o",
    iconWrapperSmallNoSpacing: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf",
    iconWrapperMediumNoSpacing: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _1o9zidpf",
    unidentifiedAgentAvatarSmall: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _ahbqv77o _12l2v77o _mkrz1k6g",
    unidentifiedAgentAvatarMedium: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _1o9zidpf _12l2v77o _mkrz1k6g",
    unidentifiedAgentAvatarSmallNoSpacing: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1tcg _4t3i1tcg _1o9zidpf _mkrz1k6g",
    unidentifiedAgentAvatarMediumNoSpacing: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _1o9zidpf _mkrz1k6g",
    brandAgentTile: "_mkrz1k6g _bfhki8nm",
    avatarOffsetInlineStart: "_t9ec1gty",
    dualAvatar: "_kqswh2mm _1bsbzwfg _4t3izwfg _1o9zidpf _12l2v77o",
    dualAvatarOffsetInlineStart: "_kqswh2mm _1bsbzwfg _4t3izwfg _1o9zidpf _12l2v77o _t9ec1gty",
    dualAvatarAgent: "_kqswstnw _154ize3t _1e02ze3t _1bsbgktf _4t3igktf _t9ec1irb _8hrz5d63",
    dualAvatarUser: "_2rko1rr0 _kqswstnw _154iutpp _rjxpv77o _1pfhv77o _bfhkvuon"
};
const $4580118d363597fd$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperMedium
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[2] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[2] = children;
            $[3] = t1;
        } else t1 = $[3];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[4] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                xcss: $4580118d363597fd$var$styles.iconWrapperSmall
            }, children);
            $[4] = children;
            $[5] = t1;
        } else t1 = $[5];
        return t1;
    }
    let t1;
    if ($[6] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $4580118d363597fd$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[6] = children;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperMedium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperSmall
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $4580118d363597fd$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $gMc0m.default)([
            "_12ra1fkg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = avatarSize === "medium" ? "medium" : "small";
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hge3g))),
            label: "",
            appearance: "gray",
            size: t2
        }));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[3] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[3] = icon;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[5] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[5] = icon;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[7] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[7] = icon;
            $[8] = t4;
        } else t4 = $[8];
        return t4;
    }
    let t4;
    if ($[9] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[9] = icon;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $gMc0m.default)([
            "_12ra1fkg"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hge3g))),
        label: "",
        appearance: "gray",
        size: avatarSize === 'medium' ? 'medium' : 'small'
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $4580118d363597fd$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise the deterministic hexagon AgentAvatar
    * (or, when the resolved agent account has a `picture`, that avatar image inside the
    * hexagon).
    */ 
const $4580118d363597fd$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(57);
    const { name: name, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2, hasInlineSpacing: t3 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const hasInlineSpacing = t3 === undefined ? true : t3;
    let t4;
    bb0: {
        if (agentIcon === "ai-agent") {
            let t5;
            if ($[0] !== avatarSize || $[1] !== hasInlineSpacing) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[0] = avatarSize;
                $[1] = hasInlineSpacing;
                $[2] = t5;
            } else t5 = $[2];
            t4 = t5;
            break bb0;
        }
        if (agentIcon === "rovo") {
            const t5 = avatarSize === "medium" ? 32 : 24;
            let t6;
            if ($[3] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
                    label: "",
                    size: t5
                });
                $[3] = t5;
                $[4] = t6;
            } else t6 = $[4];
            let t7;
            if ($[5] !== avatarSize || $[6] !== hasInlineSpacing || $[7] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t6);
                $[5] = avatarSize;
                $[6] = hasInlineSpacing;
                $[7] = t6;
                $[8] = t7;
            } else t7 = $[8];
            t4 = t7;
            break bb0;
        }
        if (agentIcon === "cursor") {
            const t5 = avatarSize === "medium" ? 32 : 24;
            let t6;
            if ($[9] !== t5) {
                t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$CursorIcon, {
                    label: "",
                    size: t5
                });
                $[9] = t5;
                $[10] = t6;
            } else t6 = $[10];
            let t7;
            if ($[11] !== avatarSize || $[12] !== hasInlineSpacing || $[13] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t6);
                $[11] = avatarSize;
                $[12] = hasInlineSpacing;
                $[13] = t6;
                $[14] = t7;
            } else t7 = $[14];
            t4 = t7;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            const t6 = avatarSize === "medium" ? 32 : 24;
            let t7;
            if ($[15] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$ClaudeIcon, {
                    label: "",
                    size: t6
                });
                $[15] = t6;
                $[16] = t7;
            } else t7 = $[16];
            let t8;
            if ($[17] !== t5 || $[18] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                    xcss: t5
                }, t7);
                $[17] = t5;
                $[18] = t7;
                $[19] = t8;
            } else t8 = $[19];
            t4 = t8;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            const t6 = avatarSize === "medium" ? 32 : 24;
            let t7;
            if ($[20] !== t6) {
                t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$ChatGptIcon, {
                    label: "",
                    size: t6
                });
                $[20] = t6;
                $[21] = t7;
            } else t7 = $[21];
            let t8;
            if ($[22] !== t5 || $[23] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                    xcss: t5
                }, t7);
                $[22] = t5;
                $[23] = t7;
                $[24] = t8;
            } else t8 = $[24];
            t4 = t8;
            break bb0;
        }
        if (agentIcon === "figma") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[25] !== t5) {
                t6 = (0, $1Whri.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[25] = t5;
                $[26] = t6;
            } else t6 = $[26];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[27] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$FigmaIcon, {
                    label: "",
                    size: t7
                });
                $[27] = t7;
                $[28] = t8;
            } else t8 = $[28];
            let t9;
            if ($[29] !== t6 || $[30] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                    xcss: t6
                }, t8);
                $[29] = t6;
                $[30] = t8;
                $[31] = t9;
            } else t9 = $[31];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[32] !== t5) {
                t6 = (0, $1Whri.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[32] = t5;
                $[33] = t6;
            } else t6 = $[33];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[34] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$DiaIcon, {
                    label: "",
                    size: t7
                });
                $[34] = t7;
                $[35] = t8;
            } else t8 = $[35];
            let t9;
            if ($[36] !== t6 || $[37] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                    xcss: t6
                }, t8);
                $[36] = t6;
                $[37] = t8;
                $[38] = t9;
            } else t9 = $[38];
            t4 = t9;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t5 = avatarSize === "medium" ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall;
            let t6;
            if ($[39] !== t5) {
                t6 = (0, $1Whri.cx)(t5, $4580118d363597fd$var$styles.brandAgentTile);
                $[39] = t5;
                $[40] = t6;
            } else t6 = $[40];
            const t7 = avatarSize === "medium" ? 32 : 24;
            let t8;
            if ($[41] !== t7) {
                t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$CodexIcon, {
                    label: "",
                    size: t7
                });
                $[41] = t7;
                $[42] = t8;
            } else t8 = $[42];
            let t9;
            if ($[43] !== t6 || $[44] !== t8) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
                    xcss: t6
                }, t8);
                $[43] = t6;
                $[44] = t8;
                $[45] = t9;
            } else t9 = $[45];
            t4 = t9;
            break bb0;
        }
        let t5;
        if ($[46] !== avatarSize || $[47] !== avatarUrl || $[48] !== name) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hezkK.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl
            });
            $[46] = avatarSize;
            $[47] = avatarUrl;
            $[48] = name;
            $[49] = t5;
        } else t5 = $[49];
        let t6;
        if ($[50] !== avatarSize || $[51] !== hasInlineSpacing || $[52] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t5);
            $[50] = avatarSize;
            $[51] = hasInlineSpacing;
            $[52] = t5;
            $[53] = t6;
        } else t6 = $[53];
        t4 = t6;
    }
    const avatar = t4;
    let t5;
    if ($[54] !== avatar || $[55] !== isOffsetInlineStart) {
        t5 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            testId: "agent-avatar-offset",
            xcss: $4580118d363597fd$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[54] = avatar;
        $[55] = isOffsetInlineStart;
        $[56] = t5;
    } else t5 = $[56];
    return t5;
} : ({ name: name, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true })=>{
    const avatar = (()=>{
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bba20334be910b9f$export$e23ae35269442b4f), {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$CursorIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$ClaudeIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$ChatGptIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'figma') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: (0, $1Whri.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$FigmaIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: (0, $1Whri.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$DiaIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: (0, $1Whri.cx)(avatarSize === 'medium' ? $4580118d363597fd$var$styles.iconWrapperMedium : $4580118d363597fd$var$styles.iconWrapperSmall, $4580118d363597fd$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$CodexIcon, {
            label: "",
            size: avatarSize === 'medium' ? 32 : 24
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hezkK.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl
        }));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "agent-avatar-offset",
        xcss: $4580118d363597fd$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
};
const $4580118d363597fd$export$524e3ea25887b088 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, userName: userName, userAvatarUrl: userAvatarUrl, isOffsetInlineStart: t1 } = t0;
    const isOffsetInlineStart = t1 === undefined ? false : t1;
    const t2 = isOffsetInlineStart ? $4580118d363597fd$var$styles.dualAvatarOffsetInlineStart : $4580118d363597fd$var$styles.dualAvatar;
    let t3;
    if ($[0] !== agentAvatarUrl || $[1] !== agentIcon || $[2] !== agentName) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $4580118d363597fd$var$styles.dualAvatarAgent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: agentName,
            agentIcon: agentIcon,
            avatarUrl: agentAvatarUrl,
            avatarSize: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
            hasInlineSpacing: false
        }));
        $[0] = agentAvatarUrl;
        $[1] = agentIcon;
        $[2] = agentName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== userAvatarUrl || $[5] !== userName) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $4580118d363597fd$var$styles.dualAvatarUser
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: userAvatarUrl,
            name: userName,
            size: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
            borderColor: "transparent",
            isDecorative: true
        }));
        $[4] = userAvatarUrl;
        $[5] = userName;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            testId: "agent-user-dual-avatar",
            xcss: t2
        }, t3, t4);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : ({ agentName: agentName, agentIcon: agentIcon, agentAvatarUrl: agentAvatarUrl, userName: userName, userAvatarUrl: userAvatarUrl, isOffsetInlineStart: isOffsetInlineStart = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        testId: "agent-user-dual-avatar",
        xcss: isOffsetInlineStart ? $4580118d363597fd$var$styles.dualAvatarOffsetInlineStart : $4580118d363597fd$var$styles.dualAvatar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.dualAvatarAgent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: agentName,
        agentIcon: agentIcon,
        avatarUrl: agentAvatarUrl,
        avatarSize: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_AGENT_SIZE,
        hasInlineSpacing: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.dualAvatarUser
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
        src: userAvatarUrl,
        name: userName,
        size: $4580118d363597fd$var$AGENT_USER_DUAL_AVATAR_USER_SIZE,
        borderColor: "transparent",
        isDecorative: true
    }))); /**
          * The agent's hexagon avatar doubles as the expand affordance: on hover or keyboard
          * focus it swaps to a chevron, and clicking it toggles the nested child rows. Keeping
          * the toggle on the avatar itself (rather than a separate inline control) matches the
          * design.
          */ 
const $4580118d363597fd$export$f483be08076d9dad = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const showChevron = isActive || isExpanded;
    const t3 = avatarSize === "medium" ? $4580118d363597fd$var$styles.toggleMedium : $4580118d363597fd$var$styles.toggleSmall;
    const t4 = isExpanded ? collapseLabel : expandLabel;
    let t5;
    if ($[0] !== onToggle) {
        t5 = (event)=>{
            event.stopPropagation();
            onToggle();
        };
        $[0] = onToggle;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsActive(true);
        t7 = ()=>setIsActive(false);
        t8 = ()=>setIsActive(true);
        t9 = ()=>setIsActive(false);
        $[2] = t6;
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
    } else {
        t6 = $[2];
        t7 = $[3];
        t8 = $[4];
        t9 = $[5];
    }
    let t10;
    if ($[6] !== agentIcon || $[7] !== avatarSize || $[8] !== avatarUrl || $[9] !== isExpanded || $[10] !== isOffsetInlineStart || $[11] !== name || $[12] !== showChevron) {
        t10 = showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        });
        $[6] = agentIcon;
        $[7] = avatarSize;
        $[8] = avatarUrl;
        $[9] = isExpanded;
        $[10] = isOffsetInlineStart;
        $[11] = name;
        $[12] = showChevron;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== isExpanded || $[15] !== t10 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
            xcss: t3,
            "aria-label": t4,
            "aria-expanded": isExpanded,
            onClick: t5,
            onMouseEnter: t6,
            onMouseLeave: t7,
            onFocus: t8,
            onBlur: t9
        }, t10);
        $[14] = isExpanded;
        $[15] = t10;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
        $[19] = t11;
    } else t11 = $[19];
    return t11;
} : ({ name: name, isExpanded: isExpanded, onToggle: onToggle, expandLabel: expandLabel, collapseLabel: collapseLabel, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false })=>{
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    const showChevron = isActive || isExpanded;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.Pressable), {
        xcss: avatarSize === 'medium' ? $4580118d363597fd$var$styles.toggleMedium : $4580118d363597fd$var$styles.toggleSmall,
        "aria-label": isExpanded ? collapseLabel : expandLabel,
        "aria-expanded": isExpanded,
        onClick: (event)=>{
            event.stopPropagation();
            onToggle();
        },
        onMouseEnter: ()=>setIsActive(true),
        onMouseLeave: ()=>setIsActive(false),
        onFocus: ()=>setIsActive(true),
        onBlur: ()=>setIsActive(false)
    }, showChevron ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
        label: ""
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    }));
}; /**
    * Renders the name-column cell for an AI-agent row: the hexagon AgentAvatar (which
    * doubles as an expand toggle when the agent has child rows) plus an optional subtitle.
    * The consuming table supplies `name`/`subtitle` from its own row model.
    */ 
const $4580118d363597fd$export$6bb3a1031846604c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: t1, isOffsetInlineStart: t2 } = t0;
    const avatarSize = t1 === undefined ? "small" : t1;
    const isOffsetInlineStart = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    let t3;
    if ($[0] !== agentIcon || $[1] !== avatarSize || $[2] !== avatarUrl || $[3] !== formatMessage || $[4] !== isExpandable || $[5] !== isExpanded || $[6] !== isOffsetInlineStart || $[7] !== name || $[8] !== onToggleExpand) {
        t3 = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$f483be08076d9dad, {
            name: name,
            isExpanded: Boolean(isExpanded),
            onToggle: onToggleExpand,
            expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
            collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
            name: name,
            agentIcon: agentIcon,
            avatarUrl: avatarUrl,
            avatarSize: avatarSize,
            isOffsetInlineStart: isOffsetInlineStart
        });
        $[0] = agentIcon;
        $[1] = avatarSize;
        $[2] = avatarUrl;
        $[3] = formatMessage;
        $[4] = isExpandable;
        $[5] = isExpanded;
        $[6] = isOffsetInlineStart;
        $[7] = name;
        $[8] = onToggleExpand;
        $[9] = t3;
    } else t3 = $[9];
    const avatar = t3;
    let t4;
    if ($[10] !== avatar || $[11] !== name || $[12] !== subtitle) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpdGL.default), {
            avatar: avatar,
            primaryText: name,
            secondaryText: subtitle
        });
        $[10] = avatar;
        $[11] = name;
        $[12] = subtitle;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ name: name, subtitle: subtitle, isExpandable: isExpandable, isExpanded: isExpanded, onToggleExpand: onToggleExpand, agentIcon: agentIcon, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', isOffsetInlineStart: isOffsetInlineStart = false })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const avatar = isExpandable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$f483be08076d9dad, {
        name: name,
        isExpanded: Boolean(isExpanded),
        onToggle: onToggleExpand,
        expandLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.expandAgentRow),
        collapseLabel: formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.collapseAgentRow),
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4580118d363597fd$export$951877a280bbd2e, {
        name: name,
        agentIcon: agentIcon,
        avatarUrl: avatarUrl,
        avatarSize: avatarSize,
        isOffsetInlineStart: isOffsetInlineStart
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpdGL.default), {
        avatar: avatar,
        primaryText: name,
        secondaryText: subtitle
    });
}; /** Wraps an agent's nested child (person) cell with a left indent. */ 
const $4580118d363597fd$export$bf2de6dc20683668 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
            xcss: $4580118d363597fd$var$styles.childIndent
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.Box), {
        xcss: $4580118d363597fd$var$styles.childIndent
    }, children); /**
                                                                           * Owns expand/collapse state and flattens parent rows into the array handed to the
                                                                           * table: each expanded agent's children are spliced directly beneath it, so sorting
                                                                           * and pagination (done by the caller) only ever act on the parent rows.
                                                                           *
                                                                           * When `sorting` is provided, an expanded agent's child (related-user) rows are sorted
                                                                           * by the same column/direction the table is sorted by, so the nested rows stay
                                                                           * consistent with the parent ordering.
                                                                           */ 
const $4580118d363597fd$export$3083e75456a22336 = (0, $3u0dr.isReactCompilerActiveV2)() ? (parentRows, childrenByAgentId, sorting)=>{
    const $ = (0, $frIzR.c)(6);
    const [expandedAgentIds, setExpandedAgentIds] = (0, $42omo.useState)($4580118d363597fd$var$_temp);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (agentId)=>{
            setExpandedAgentIds((previous)=>{
                const next = new Set(previous);
                if (next.has(agentId)) next.delete(agentId);
                else next.add(agentId);
                return next;
            });
        };
        $[0] = t0;
    } else t0 = $[0];
    const toggleAgentExpansion = t0;
    let rows;
    if ($[1] !== childrenByAgentId || $[2] !== expandedAgentIds || $[3] !== parentRows || $[4] !== sorting) {
        rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) {
                    const children = childrenByAgentId[agentId_0] ?? [];
                    rows.push(...sorting ? [
                        ...children
                    ].sort((0, $hjyA9.sortByState)(sorting)) : children);
                }
            } else rows.push(row);
        });
        $[1] = childrenByAgentId;
        $[2] = expandedAgentIds;
        $[3] = parentRows;
        $[4] = sorting;
        $[5] = rows;
    } else rows = $[5];
    return rows;
} : (parentRows, childrenByAgentId, sorting)=>{
    const [expandedAgentIds, setExpandedAgentIds] = (0, $42omo.useState)(()=>new Set());
    const toggleAgentExpansion = (0, $42omo.useCallback)((agentId)=>{
        setExpandedAgentIds((previous)=>{
            const next = new Set(previous);
            if (next.has(agentId)) next.delete(agentId);
            else next.add(agentId);
            return next;
        });
    }, []);
    return (0, $42omo.useMemo)(()=>{
        const rows = [];
        parentRows.forEach((row)=>{
            const { isAgent: isAgent, isExpandable: isExpandable, agentId: agentId_0 } = row.data;
            if (isAgent && isExpandable && agentId_0) {
                const isExpanded = expandedAgentIds.has(agentId_0);
                rows.push({
                    ...row,
                    data: {
                        ...row.data,
                        isExpanded: isExpanded,
                        onToggleExpand: ()=>toggleAgentExpansion(agentId_0)
                    }
                });
                if (isExpanded) {
                    const children = childrenByAgentId[agentId_0] ?? [];
                    rows.push(...sorting ? [
                        ...children
                    ].sort((0, $hjyA9.sortByState)(sorting)) : children);
                }
            } else rows.push(row);
        });
        return rows;
    }, [
        parentRows,
        childrenByAgentId,
        expandedAgentIds,
        toggleAgentExpansion,
        sorting
    ]);
};
const $4580118d363597fd$export$24e644fa464a5e9f = (formatMessage, name, count)=>formatMessage($4580118d363597fd$export$8f1cb3c7f8edc6be.agentSubtitle, {
        name: name,
        count: count
    });
function $4580118d363597fd$var$_temp() {
    return new Set();
}
module.exports["agentActivityI18n"] = $4580118d363597fd$export$8f1cb3c7f8edc6be;
module.exports["AgentRowAvatar"] = $4580118d363597fd$export$951877a280bbd2e;
module.exports["AgentUserDualAvatar"] = $4580118d363597fd$export$524e3ea25887b088;
module.exports["AgentChildRowIndent"] = $4580118d363597fd$export$bf2de6dc20683668;
module.exports["useExpandableAgentRows"] = $4580118d363597fd$export$3083e75456a22336;
module.exports["getAgentSubtitle"] = $4580118d363597fd$export$24e644fa464a5e9f;

});

parcelRegister("4lbbz", function(module, exports) {

let $3291cccdd76c1ad0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3291cccdd76c1ad0$var$load("3JFXu").then(()=>parcelRequire('6DKnm'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("cUEQB", function(module, exports) {

let $026d122b09959adf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $026d122b09959adf$var$load("8FO7k").then(()=>parcelRequire('68voD'));

});

parcelRegister("2F3cm", function(module, exports) {

let $1f01e44060f7edb5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1f01e44060f7edb5$var$load("2vGEp").then(()=>parcelRequire('4QNrJ'));

});

parcelRegister("3CO4t", function(module, exports) {

let $2a3bc2cc4b9edced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a3bc2cc4b9edced$var$load("39gUe").then(()=>parcelRequire('cC6Gf'));

});

parcelRegister("knPv8", function(module, exports) {

let $ed6de7afde6555bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ed6de7afde6555bc$var$load("iEop5").then(()=>parcelRequire('4x9Sq'));

});

parcelRegister("7bNvW", function(module, exports) {

let $53bff7faffbaa887$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53bff7faffbaa887$var$load("dNCzW").then(()=>parcelRequire('fghXu'));

});


//# sourceMappingURL=AnalyticsByLine.800ae47c.js.map
